// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_gUT","cls2":"WorkCard-cls2_4Cv WorkCard-cls1_gUT"};